var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.baseCss, _vm.visible ? 'line-ripple-visible' : null, _vm.setBgColor()],style:({height: _vm.height}),attrs:{"role":"complementary"}},[_c('div',{class:['transition-all', 'duration-500', 'absolute', 'block', _vm.setBgColor('rippleBgColor', 'rippleBgColorLightness')]})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-465942cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/line-ripple/line-ripple.vue
// module id = null
// module chunks = 